import IntegerType from './IntegerType';
export default IntegerType;
